import React, { useEffect, useState } from 'react'
import Lottie from 'lottie-react'

// next components

// third party component

// custom functions

// styles
import styles from './index.module.scss'
import ProfileSortMenu from 'components/Menu/ProfileSortMenu'
import SortIcon from 'assets/icons/sort-icon-normal.svg?component'
import GradientButton from 'components/Button/GradientButton'
import FilterIcon from 'assets/icons/filter-icon.svg?component'
import RefreshIcon from 'assets/icons/refresh-icon-mobile.svg?component'
import OutlineButton from 'components/Button/OutlineButton'
import RefreshMobileLottery from 'assets/lottery/refresh-mobile.json'
import ArtworkTab from './ArtworkTab'
import ActivityTab from './ActivityTab'

const ProfileTab = props => {
  const {
    activeTab,
    sortList,
    handleSelectSort,
    ownershipList,
    handleOwnership,
    showFilter,
    setShowFilter,
    openMobileFilter,
    setOpenMobileFilter,
    refreshing,
    refreshNFT,
    shownOfferType,
    setShownOfferType,
    filterKey,
    setFilterKey,
    favoriteType,
    setFavoriteType,
    hasLoading,
  } = props

  return (
    <div className={styles.container}>
      <div className="w-full flex flex-wrap justify-between gap-[30px] lg:gap-[15px]">
        {activeTab === 0 ? (
          <div className="w-full lg:w-auto flex lg:hidden">
            <div
              className={`${styles.profileFilter} ${showFilter ? styles.selectedFilter : styles.unselectedFilter}`}
              onClick={() => setOpenMobileFilter(!openMobileFilter)}
            >
              <FilterIcon />
            </div>
            <ProfileSortMenu categoryList={sortList} handleSelectCategory={handleSelectSort} icon={<SortIcon />} />
          </div>
        ) : (
          <div className="w-full"></div>
        )}

        {activeTab === 0 && <ArtworkTab ownershipList={ownershipList} handleOwnership={handleOwnership} />}

        {activeTab === 1 && (
          <div className="flex gap-[12px] overflow-x-scroll">
            <div className="min-w-[164px]">
              {shownOfferType === 'received' ? (
                <GradientButton
                  label="Offers Received"
                  backgroundColor={'var(--bg-FFF-202427)'}
                  width={164}
                  height={43}
                  onClick={() => {}}
                />
              ) : (
                <OutlineButton
                  label="Offers Received"
                  backgroundColor={'rgba(var(--main-bg-color-rgb), 0.1)'}
                  fontFamily="Jost-Regular"
                  color="var(--bg-A5A5A5-606060)"
                  borderColor="transparent"
                  width={164}
                  height={43}
                  onClick={() => {
                    setShownOfferType('received')
                  }}
                />
              )}
            </div>

            <div className="min-w-[138px]">
              {shownOfferType === 'made' ? (
                <GradientButton
                  label="Offers Made"
                  backgroundColor={'var(--bg-FFF-202427)'}
                  width={138}
                  height={43}
                  onClick={() => {}}
                />
              ) : (
                <OutlineButton
                  label="Offers Made"
                  backgroundColor={'rgba(var(--main-bg-color-rgb), 0.1)'}
                  fontFamily="Jost-Regular"
                  color="var(--bg-A5A5A5-606060)"
                  borderColor="transparent"
                  width={138}
                  height={43}
                  onClick={() => {
                    setShownOfferType('made')
                  }}
                />
              )}
            </div>
          </div>
        )}

        {activeTab === 2 && <ActivityTab filterKey={filterKey} setFilterKey={setFilterKey} />}

        {activeTab === 3 && (
          <div className="flex gap-[12px] overflow-x-scroll">
            <div className="min-w-[106px]">
              {favoriteType === 0 ? (
                <GradientButton
                  label="Artwork"
                  backgroundColor={'var(--bg-FFF-202427)'}
                  width={106}
                  height={43}
                  onClick={() => {}}
                />
              ) : (
                <OutlineButton
                  label="Artwork"
                  backgroundColor={'rgba(var(--main-bg-color-rgb), 0.1)'}
                  fontFamily="Jost-Regular"
                  color="var(--bg-A5A5A5-606060)"
                  borderColor="transparent"
                  width={106}
                  height={43}
                  onClick={() => {
                    setFavoriteType(0)
                  }}
                />
              )}
            </div>

            <div className="min-w-[122px]">
              {favoriteType === 1 ? (
                <GradientButton
                  label="Collection"
                  backgroundColor={'var(--bg-FFF-202427)'}
                  width={122}
                  height={43}
                  onClick={() => {}}
                />
              ) : (
                <OutlineButton
                  label="Collection"
                  backgroundColor={'rgba(var(--main-bg-color-rgb), 0.1)'}
                  fontFamily="Jost-Regular"
                  color="var(--bg-A5A5A5-606060)"
                  borderColor="transparent"
                  width={122}
                  height={43}
                  onClick={() => {
                    setFavoriteType(1)
                  }}
                />
              )}
            </div>
          </div>
        )}

        {activeTab === 4 && <div className="w-[100px] h-[0px]"></div>}

        <div className="hidden lg:flex">
          {activeTab === 0 && (
            <div
              className={`${styles.profileFilter} ${showFilter ? styles.selectedFilter : styles.unselectedFilter}`}
              onClick={() => setShowFilter(!showFilter)}
            >
              <FilterIcon />
            </div>
          )}

          {activeTab === 0 && (
            <ProfileSortMenu categoryList={sortList} handleSelectCategory={handleSelectSort} icon={<SortIcon />} />
          )}

          <div className={styles.refreshBtn} onClick={() => refreshNFT()}>
            {refreshing ? (
              <Lottie width={20} height={20} animationData={RefreshMobileLottery} loop={true} className="mt-1" />
            ) : (
              <div>
                <RefreshIcon />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProfileTab
